/* ===========================================================
   card-stretched-overlay.js
   -----------------------------------------------------------
   On card systems where only the image is a link (gpn-card,
   sir-card, bc-card — all three share <article> + image <a> +
   body <div> markup), add a real <a> overlay that fills the
   entire card so clicking anywhere navigates to the PDP.

   Pure-CSS ::after doesn't work here because the imgwrap link
   has position:relative + overflow:hidden (required for image
   fill + savebadge positioning), which traps any pseudo inside
   the image area only.

   Buttons + variant pickers inside the card body keep their own
   z-index (set in theme.css) and stay independently clickable.

   Reverse: delete this file and its <script> include in
   layout/theme.liquid.
   =========================================================== */
(function () {
  'use strict';

  var TARGET_SELECTOR = '.mkp-card:not([data-card-overlay]), .gpn-card:not([data-card-overlay]), .sir-card:not([data-card-overlay]), .bc-card:not([data-card-overlay])';

  function decorate(root) {
    var cards = (root || document).querySelectorAll(TARGET_SELECTOR);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var imgLink = card.querySelector('a.mkp-card__imgwrap, a[class*="__imgwrap"]');
      if (!imgLink) continue;
      var href = imgLink.getAttribute('href');
      if (!href) continue;

      // Mark as processed before mutating, so the MutationObserver doesn't loop
      card.setAttribute('data-card-overlay', '1');

      if (getComputedStyle(card).position === 'static') {
        card.style.position = 'relative';
      }

      var overlay = document.createElement('a');
      overlay.href = href;
      overlay.className = 'card-stretched-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.tabIndex = -1;
      overlay.style.cssText = 'position:absolute;inset:0;z-index:1;background:transparent;';
      card.appendChild(overlay);
    }
  }

  // Always sweep the whole document — cheap operation, the :not() selector
  // skips any card we've already processed. Belt-and-suspenders across the
  // various ways cards get inserted (server-rendered, JS-rendered, ajax
  // pagination, filter changes, app re-renders).
  function sweep() { decorate(document); }

  function init() {
    sweep();
    // Run again after a beat in case cards come from a later JS pass
    setTimeout(sweep, 300);
    setTimeout(sweep, 1500);
    // And keep watching — any DOM change triggers a sweep
    var observer = new MutationObserver(sweep);
    observer.observe(document.body, { childList: true, subtree: true });
    // Final fallback on full load
    window.addEventListener('load', sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
